﻿export function initCurrentSituationPage() {
    const loanParts = document.querySelectorAll("[data-loan-part-index]");
    loanParts.forEach(initializeLoanPart);

    const form = document.querySelector("form");
    if (form) {
        form.removeEventListener("sds:form:validated", handleCurrentSituationFormValidated);
        form.addEventListener("sds:form:validated", handleCurrentSituationFormValidated);

        form.removeEventListener("sds:form:beforeSubmit", handleCurrentSituationBeforeSubmit);
        form.addEventListener("sds:form:beforeSubmit", handleCurrentSituationBeforeSubmit);
    }

    const redemptionCheckboxes = document.querySelectorAll("[data-redemption-choice-checkbox='true']");
    redemptionCheckboxes.forEach(registerRedemptionCheckbox);
}

function initializeLoanPart(container) {
    const index = container.dataset.loanPartIndex;
    const radios = container.querySelectorAll(`input[name="MortgageCheckLoanPart[${index}].Input.HasAllowedTaxDeduction.Value"]`);
    const endDateField = container.querySelector("[data-end-date-field]");

    if (!endDateField || radios.length === 0) {
        return;
    }

    updateEndDateVisibility(radios, endDateField);
    radios.forEach(registerRadioChange);
}

function registerRadioChange(radio) {
    radio.removeEventListener("change", handleRadioChange);
    radio.addEventListener("change", handleRadioChange);
}

function handleRadioChange(event) {
    const radio = event.currentTarget;
    const container = radio.closest("[data-loan-part-index]");

    if (!container) {
        return;
    }

    const index = container.dataset.loanPartIndex;
    const radios = container.querySelectorAll(`input[name="MortgageCheckLoanPart[${index}].Input.HasAllowedTaxDeduction.Value"]`);
    const endDateField = container.querySelector("[data-end-date-field]");

    if (!endDateField || radios.length === 0) {
        return;
    }

    updateEndDateVisibility(radios, endDateField);
}

function updateEndDateVisibility(radios, endDateField) {
    const selectedRadio = Array.from(radios).find(isCheckedRadio);

    if (selectedRadio) {
        endDateField.hidden = selectedRadio.value !== "Ja";
    }
}

function isCheckedRadio(radio) {
    return radio.checked;
}

function registerRedemptionCheckbox(checkbox) {
    checkbox.removeEventListener("change", handleRedemptionCheckboxChange);
    checkbox.addEventListener("change", handleRedemptionCheckboxChange);
}

function handleRedemptionCheckboxChange(event) {
    const checkbox = event.currentTarget;
    const formFieldGroup = checkbox.closest("[data-redemption-choices-group='true']");

    if (!formFieldGroup) {
        return;
    }

    validateRedemptionGroup(formFieldGroup);
}

function handleCurrentSituationFormValidated(event) {
    const form = event.currentTarget;
    const groups = form.querySelectorAll("[data-redemption-choices-group='true']");

    groups.forEach(function validateGroup(group) {
        validateRedemptionGroup(group);
    });
}

function handleCurrentSituationBeforeSubmit(event) {
    const form = event.currentTarget;
    const groups = form.querySelectorAll("[data-redemption-choices-group='true']");
    let hasValidationErrors = false;
    let firstInvalidGroup = null;

    groups.forEach(function validateGroup(group) {
        if (!validateRedemptionGroup(group)) {
            hasValidationErrors = true;

            if (!firstInvalidGroup) {
                firstInvalidGroup = group;
            }
        }
    });

    if (hasValidationErrors) {
        event.preventDefault();

        // Also reset all loadable buttons
        const loadableButtons = form.querySelectorAll(".btn");
        loadableButtons.forEach(function resetButton(button) {
            button.classList.remove("loading");
        });

        const firstCheckbox = firstInvalidGroup?.querySelector("[data-redemption-choice-checkbox='true']");
        firstCheckbox?.focus?.();
    }
}

function validateRedemptionGroup(formFieldGroup) {
    const checkboxes = formFieldGroup.querySelectorAll("[data-redemption-choice-checkbox='true']");
    const validationMessageElement = formFieldGroup.querySelector(":scope > .error [data-valmsg-for]");
    const message = formFieldGroup.dataset.redemptionRequiredMessage;

    if (checkboxes.length === 0) {
        return true;
    }

    const hasAtLeastOneChecked = Array.from(checkboxes).some(isCheckedCheckbox);

    if (hasAtLeastOneChecked) {
        formFieldGroup.classList.remove("is-invalid");

        if (validationMessageElement) {
            validationMessageElement.classList.remove("field-validation-error");
            validationMessageElement.classList.add("field-validation-valid");
            validationMessageElement.textContent = "";
        }

        return true;
    }

    formFieldGroup.classList.add("is-invalid");

    if (validationMessageElement) {
        validationMessageElement.classList.remove("field-validation-valid");
        validationMessageElement.classList.add("field-validation-error");
        validationMessageElement.textContent = message;
    }

    return false;
}

function isCheckedCheckbox(checkbox) {
    return checkbox.checked;
}

